import { RockCheckInRecord } from '../../types'
import UserAvatar from '../shared/UserAvatar'

interface Props {
  checkIns: RockCheckInRecord[]
  targetType?: 'number' | 'currency' | 'percentage' | null
}

function timeAgo(dateStr: string): string {
  const date = new Date(dateStr)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffMins = Math.floor(diffMs / 60000)
  if (diffMins < 1) return 'Just now'
  if (diffMins < 60) return `${diffMins}m ago`
  const diffHours = Math.floor(diffMins / 60)
  if (diffHours < 24) return `${diffHours}h ago`
  const diffDays = Math.floor(diffHours / 24)
  if (diffDays < 7) return `${diffDays}d ago`
  const diffWeeks = Math.floor(diffDays / 7)
  return `${diffWeeks}w ago`
}

function formatValue(val: number | null, targetType: string | null | undefined): string {
  if (val === null || val === undefined) return ''
  switch (targetType) {
    case 'currency': return `$${val.toLocaleString()}`
    case 'percentage': return `${val}%`
    default: return val.toLocaleString()
  }
}

function pctColor(pct: number): string {
  if (pct >= 100) return '#1B7340'
  if (pct >= 75) return '#5BA84B'
  if (pct >= 50) return '#FBA737'
  if (pct >= 25) return '#F08A3A'
  return '#ED1C24'
}

function fmtPct(p: number): string {
  return p % 1 === 0 ? `${p}%` : p.toFixed(1) + '%'
}

export default function RockCheckInHistory({ checkIns, targetType }: Props) {
  if (checkIns.length === 0) {
    return (
      <div className="text-center py-6 text-text-muted text-sm">
        No check-ins yet
      </div>
    )
  }

  return (
    <div className="space-y-3">
      {checkIns.map(ci => {
        const pct = ci.percent_complete
        const c = pct !== null && pct !== undefined ? pctColor(pct) : '#999'
        return (
          <div key={ci.id} className="flex items-start gap-3 py-2 border-b border-stone/10 last:border-0">
            <UserAvatar user={ci.user} size="sm" className="mt-0.5" />
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-text-primary">{ci.user.full_name}</span>
                {pct !== null && pct !== undefined && (
                  <span
                    className="text-[12px] font-bold px-2 py-0.5 rounded-full tabular-nums"
                    style={{ backgroundColor: `${c}26`, color: c }}
                  >
                    {fmtPct(pct)}
                  </span>
                )}
                {ci.value !== null && (
                  <span className="text-sm text-text-secondary">{formatValue(ci.value, targetType)}</span>
                )}
                <span className="text-sm text-text-muted ml-auto whitespace-nowrap">{timeAgo(ci.created_at)}</span>
              </div>
              {ci.note && (
                <p className="text-sm text-text-secondary mt-1">{ci.note}</p>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}
